import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ApiRequestService } from '../../../BaseFramework/core/http/api-request.service';
import { CommonUtilty } from 'app';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrgDataService {

  constructor(private apiRequest: ApiRequestService,
    private commonUtility: CommonUtilty,
    private http: HttpClient) { }

  fetchWholeOrgHierarchy() {
    let wholeOrgData = new Subject<any>();
  //this needs to be changes as per company not by any specific user
    this.apiRequest.getCallWithAPIMapper("fetchUserHierarchy")
      .subscribe(jsonResp => {
        let returnObj = jsonResp;
        wholeOrgData.next(returnObj);
      });

    return wholeOrgData;
  }

  fetchUserHierarchy(loggedInUserID = null) {
    let userHierarchyData = new Subject<any>();

    let parameter = [loggedInUserID]
    this.apiRequest.getCallWithAPIMapper("fetchLoggedInUserHierarchy",null,null,parameter) 
      .subscribe(jsonResp => {
        let returnObj = jsonResp;
        userHierarchyData.next(returnObj);
      });

    return userHierarchyData;
  }

  fetchUserHierarchyTillLevel(loggedInUserID = null) {
    let userHierarchyDataTillLevel = new Subject<any>();
    let parameter = [loggedInUserID]
    this.apiRequest.getCallWithAPIMapper("fetchLoggedInUserHierarchy",null,null,parameter) 
      .subscribe(jsonResp => {
        let returnObj = jsonResp;
        userHierarchyDataTillLevel.next(returnObj);
      });

    return userHierarchyDataTillLevel;
  }

}
